import Empty from './../empty.tsx';
export const assingUnitableApiMethods = () => { };
export const isMatchCustomerManageRoute = () => false;
export const isMatchCustomerPerformanceRoute = () => false;
export const useL2cCrmSidebarMenu = () => null;
export const isMatchUnitableCrmHash = () => false;
export const unitableRouteHashPrefix = '/unitable-crm';
export const showUniDrawer = () => { };
export const UniDrawerModuleId = {};
export const L2cCrmPageType = {};
export const L2cCrmPageTypeSet = new Set();
export const L2cCrmSidebarMenuExtra = {};
export const showColdRcModal = () => { };
export const removeAllMiniDrawer = () => { };
export const useL2cCrmUnreadCount = () => { };
export const SelectReceiptModal = () => { };
export const SiriusCustomerTagByEmail = Empty;
export const findTopPriorityLabel = () => { };
export const Module = {};
export const scenes = {};
export const routeMenu = {
    contacts: {
        path: '/contacts/list',
        label: '',
    },
    recommendList: {
        path: '/recommend/list',
        label: '',
    },
    lead: {
        path: '/lead/list',
        label: '',
    },
    publicLeadList: {
        path: '/lead/public/list',
        label: '',
    },
    teamLeadList: {
        path: '/lead/team/list',
        label: '',
    },
    custom: {
        path: '/custom/list',
        label: '',
    },
    customLabel: {
        path: '/custom/label/list',
        label: '',
    },
    publicCustom: {
        path: '/custom/public/list',
        label: '',
    },
    recommendCustom: {
        path: '/custom/recommend/list',
        label: '',
    },
    business: {
        path: '/business/list',
        label: '',
    },
    quotation: {
        path: '/quotation/list',
        label: '',
    },
    sellOrder: {
        path: '/sell-order/list',
        label: '',
    },
    paymentPlan: {
        path: '/payment-play/list',
        label: '',
    },
    paymentReceipt: {
        path: '/payment-receipt/list',
        label: '',
    },
    paymentRegistration: {
        path: '/payment-registration/list',
        label: '',
    },
    effectivePrice: {
        path: '/price/effective',
        label: '',
    },
    pendingPrice: {
        path: '/price/pending',
        label: '',
    },
    localProduct: {
        path: '/product/local/list',
        label: '',
    },
    platformProduct: {
        path: '/product/platform/list',
        label: '',
    },
    supplierManagement: {
        path: '/supplier/management',
        label: '',
    },
    demo: {
        path: '/demo',
        label: '',
    },
    phrase: {
        path: '/phrase',
        label: '',
    },
    autoRecommend: {
        path: '/autoRecommend',
        label: '',
    },
    customRecommend: {
        path: '/customRecommend',
        label: '',
    },
    recommendOperateList: {
        path: '/recommendOperateList',
        label: '',
    },
    authorization: {
        path: '/authorization',
        label: '',
    },
    saleSetting: {
        path: '/sale/setting',
        label: '',
    },
    saleDashboard: {
        path: '/sale/dashboard',
        label: '',
    },
    saleDataDashboard: {
        path: '/sale/data/dashboard',
        label: '',
    },
    saleDiagnose: {
        path: '/sale/diagnose',
        label: '',
    },
    customerDetail: {
        path: '',
    },
    performanceDetail: {
        path: '',
    },
};
